import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';
import type { FC, MouseEventHandler } from 'react';
import { useState } from 'react';
import { Picture, Tooltip } from '@ui';
import icons from '@icons';
import { useStores } from '@root/src/stores';

const {
  heart: { black: heartBlackOutlined }
} = icons.Outline;

const {
  heart: { darkRed: heartDRFilled }
} = icons.Fill;

interface FavoriteProps {
  id: number;
  isFavorite: boolean;
  isMobile?: boolean;
}
const Favorite: FC<FavoriteProps> = observer(
  ({ id, isFavorite, isMobile = false }) => {
    const { catalogStore, userStore, modalsStore } = useStores();
    const [isFav, setIsFav] = useState(isFavorite);
    const addToFavourites = (): void => {
      catalogStore
        .addToFavourites({
          postponed: false,
          action: isFav ? 'remove' : 'add',
          objectId: +id,
          object: 'catalog'
        })
        .then(() => {
          setIsFav(prev => !prev);
          if (!isFav) {
            window?.dataLayer?.push({
              event: 'webit_add_to_favorites',
              eventAction: 'add',
              productId: id
            });
          }
        });
    };
    const prepareToAddToFavourites: MouseEventHandler = e => {
      e.preventDefault();

      const { user } = userStore;
      const { changeAuthModalState } = modalsStore;
      if (isEmpty(user)) {
        changeAuthModalState();
      } else {
        addToFavourites();
      }
    };
    const component = (
      <div
        className='flex items-center justify-center w-8 h-8 bg-white rounded-full cursor-pointer'
        onClick={prepareToAddToFavourites}
      >
        <Picture
          icon={isFav ? heartDRFilled : heartBlackOutlined}
          width={20}
          height={20}
          alt='Heart'
        />
      </div>
    );
    if (isMobile) {
      return component;
    }
    return (
      <Tooltip
        offsetY={0}
        centeredText
        on={['hover', 'focus']}
        tooltipText={
          isFav ? 'Убрать товар из избранного' : 'Добавить товар в избранное'
        }
      >
        {component}
      </Tooltip>
    );
  }
);

export default Favorite;
